const BASE  = '/testback/';
// const BASE  = 'http://localhost:8080/honghclient/';
//const BASES = 'http://localhost:8080/html/'

const URL   = {
  HxUser       : BASE + 'videos/imRegister',
  HxDoctor     : BASE + 'videos/getVideoStaffMobile',
  VideoRecord  : BASE + 'videos/addVideoRecord',
  VideoCard    : BASE + 'videos/tencentCheckUserCanVideo',
  EVideoRecord : BASE + 'videos/tencentUpdateVideoRecord',
  // RecordList   : BASE + 'videos/videoHistory',
  Comment      : BASE + 'comment/tag',
  Evaluation   : BASE + 'videoEvaluation/getEvaluation',
  PostComment  : BASE + 'videoEvaluation/Evaluation',
  VideoEmr     : BASE + 'videoEmr/getVideoEmr',
  // patient      : BASE + 'patient/selectPatientListByAccountId',
  // addPatient   : BASE + 'patient/addPatient',
  // updatePatient: BASE + 'patient/updatePatient',
  // Tencent      : BASE + 'videos/tencentAddParientsInfo',
  // checkUserCan : BASE + 'videos/checkUserCanVideo/',
  generateImg  : BASE + 'videos/generateImgUrl',
  EvaluationInfo : BASE + 'videos/tencentEvaluationInfo',
  // homecare     : BASE + 'homecare/detail',
};
module.exports = URL;




// WEBPACK FOOTER //
// ./src/assets/js/url.js